import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { BirthdayInput } from "@/components/ui/BirthdayInput";
import { RegisterFormData } from "../schema";

interface DateFieldProps {
  control: Control<RegisterFormData>;
}

export const DateField = ({ control }: DateFieldProps) => {
  const { t } = useTranslation();

  return (
    <BirthdayInput
      name="dateOfBirth"
      control={control}
      label={t("register.labels.dateOfBirth")}
      required={true}
    />
  );
};